import { Box, Paper, Tooltip, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ChevronDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ChevronUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ShoppingBagIcon from "@material-ui/icons/LocalMall";
import React from "react";

import EmptyTableState from "../EmptyTableState/EmptyTableState";
import OrderRow from "../OrderRow/OrderRow";
import useStyles from "./WithdrawalAlert.styles";
import { colors } from "../../tokens";

export default function WithdrawalAlert({ data, isEmpty, onRowClick }) {
	const classes = useStyles();
	const [expanded, setExpanded] = React.useState(false);
	const ToggleIcon = expanded ? ChevronUpIcon : ChevronDownIcon;

	if (isEmpty) {
		return <EmptyTableState stateKey="withdrawal" fullWidth />;
	}

	return (
		<Paper className={classes.withdrawal}>
			<Box
				className={classes.withdrawalHeader}
				style={{ background: colors.tables[data?.variant] || data?.variant }}
				onClick={() => setExpanded((prevExpanded) => !prevExpanded)}
			>
				<div className={classes.withdrawalLeft}>
					<ShoppingBagIcon className={classes.bagIcon} />
					<Typography className={classes.withdrawalText}>
						<span className={classes.withdrawalBold}>{data?.count}</span>{" "}
						{data?.title}
					</Typography>
					<Tooltip
						title={data?.infoText}
						classes={{ tooltip: classes.customTooltip }}
						placement="top"
					>
						<InfoOutlinedIcon className={classes.infoIcon} />
					</Tooltip>
				</div>
				<ToggleIcon className={classes.rowArrow} />
			</Box>
			{expanded && (
				<>
					<div className={classes.withdrawalTableHead}>
						{data?.columns.map((column, index) => (
							<Typography
								className={`${classes.tableCell} ${classes.tableHeadCell}`}
								key={`${index}-${column}`}
							>
								{column}
							</Typography>
						))}
						<span />
					</div>
					<div className={classes.withdrawalRowsScroll}>
						{data?.rows.map((row, index) => (
							<OrderRow
								key={`${index}-${row[0]}`}
								className={classes.withdrawalRow}
								columns={row}
								onClick={onRowClick}
							/>
						))}
					</div>
				</>
			)}
		</Paper>
	);
}
